import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import { GLOBAL_IMAGES } from "../../assets/asset";
import AboutContent from "../../components/about/AboutContent";

const ParentAboutPage = () => {
  return (
    <div className="parent-about-page min-h-screen bg-[#f8f3ea] font-mali text-[#1b1b1b]">
      <div className="mx-auto flex min-h-screen max-w-7xl flex-col px-4 pb-10 pt-6 sm:px-6 lg:px-8">
        <header className="border-b border-[#ddd3c6] pb-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <Link className="flex items-center gap-3" to="/tutorinfo">
              <img
                src={GLOBAL_IMAGES.dingo}
                alt="MathDingo"
                className="h-12 w-12 object-contain"
              />
              <img
                src={GLOBAL_IMAGES.dingoLogoText}
                alt="MathDingo"
                className="h-8 w-auto object-contain sm:h-9"
              />
            </Link>

            <Link
              to="/tutorinfo"
              className="inline-flex items-center gap-2 rounded-full border border-[#d8cfbf] bg-white px-5 py-2.5 text-sm font-bold text-[#0B2B66] transition hover:border-[#08059B] hover:text-[#08059B] sm:text-base"
            >
              <ArrowLeft size={18} />
              Back to Tutor Info
            </Link>
          </div>
        </header>

        <main className="flex-1 py-10">
          <section className="relative overflow-hidden rounded-[36px] border border-[#ddd3c6] bg-[linear-gradient(135deg,#fff8ef_0%,#f7ead9_42%,#efe5ff_100%)] p-8 shadow-[0_24px_60px_rgba(11,43,102,0.08)] sm:p-10">
            <div className="absolute right-[-40px] top-[-30px] h-36 w-36 rounded-full bg-[#fff0ec]/80 blur-2xl" />
            <div className="absolute bottom-[-50px] left-[-20px] h-44 w-44 rounded-full bg-[#dff2eb]/80 blur-2xl" />

            <div className="relative max-w-3xl">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/85 px-4 py-2 text-sm font-bold text-[#9d5229] shadow-sm">
                <Sparkles size={16} />
                Parent Access
              </span>

              <h1 className="mt-6 text-4xl font-bold leading-tight text-[#0B2B66] sm:text-5xl">
                About MathDingo
              </h1>

              <p className="mt-5 text-lg leading-8 text-[#334155]">
                Explore the same MathDingo story, plans, and learning approach in
                the public parent experience before logging in or creating an
                account.
              </p>
            </div>
          </section>

          <section className="mt-8 overflow-hidden rounded-[36px] border border-[#ddd3c6] bg-white shadow-[0_24px_60px_rgba(11,43,102,0.08)]">
            <div
              style={{
                backgroundImage: `url(${GLOBAL_IMAGES.onboarding_bg})`,
                backgroundAttachment: "fixed",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
              className="min-h-full"
            >
              <AboutContent />
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default ParentAboutPage;
